import * as React from 'react'

interface TooltipProps {
  label: string
  children: React.ReactNode
  /** use 'right' near the viewport's right edge — the hidden bubble still occupies
   * layout space, so a centered one would create horizontal page overflow there */
  align?: 'center' | 'right'
}

/** CSS-only hover tooltip (Flowbite-style dark pill with arrow, shown above the target). */
export const Tooltip: React.FC<TooltipProps> = ({ label, children, align = 'center' }) => (
  <div className="group/tooltip relative inline-flex">
    {children}
    <div
      role="tooltip"
      className={`pointer-events-none absolute bottom-full z-20 mb-2 whitespace-nowrap rounded-lg bg-gray-900 px-3 py-1.5 text-xs font-medium text-white opacity-0 shadow-sm transition-opacity duration-150 group-hover/tooltip:opacity-100 ${
        align === 'right' ? 'right-0' : 'left-1/2 -translate-x-1/2'
      }`}
    >
      {label}
      <div
        className={`absolute -bottom-1 h-2 w-2 rotate-45 bg-gray-900 ${
          align === 'right' ? 'right-3' : 'left-1/2 -translate-x-1/2'
        }`}
      />
    </div>
  </div>
)
